<template>
  <label
    class="radio-wrapper"
    :class="{ disabled: disabled, checked: checked }"
  >
    <input
      :id="id"
      type="radio"
      :value="value"
      :model="model"
      :disabled="disabled"
      :checked="checked"
      @change="onChange"
    />
    <span
      class="radio"
      :style="{ height: `${size}px`, width: `${size}px` }"
    ></span>
    <span class="label" v-if="label">{{ label }}</span>
  </label>
</template>

<script>
  export default {
    name: "Radio",
    props: {
      id: String,
      checked: {
        type: Boolean,
        default: false
      },
      disabled: Boolean,
      size: {
        type: String,
        default: "16"
      },
      label: {
        type: String,
        default: null
      },
      value: {
        type: [Number, String],
        default: ""
      },
      model: {
        type: String,
        defaul: null
      }
    },
    methods: {
      onChange(event) {
        this.$emit("change", event);
      }
    }
  };
</script>

<style scoped lang="scss">
  .radio-wrapper {
    display: flex;
    align-items: center;

    > input {
      opacity: 0;
      position: absolute;
      z-index: 1;

      &:focus {
        + .radio {
          box-shadow: 0 0 5px rgba($color-secondary, 0.05);
          border-color: $color-secondary;
        }
      }

      &:hover {
        cursor: pointer;
      }
    }

    .radio {
      line-height: 1em;
      border: 2px solid #aeb7bf;
      border-radius: 50%;
      display: inline-block;
      transition: $transition;
      position: relative;
      z-index: 2;
    }

    .label {
      margin-left: 8px;
    }

    &.checked {
      .radio {
        border-color: $color-secondary;

        &:after {
          content: "";
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 12px;
          height: 12px;
          border-radius: 6px;
          background: $color-secondary;
        }
      }

      > input:focus + .radio {
        box-shadow: 0 0 10px $color-secondary;
      }
    }
    &.disabled {
      color: #ddd;

      .radio {
        background: #ddd;
        border-color: #ddd;
        color: #888;
      }

      &:hover {
        cursor: not-allowed;
      }
    }

    &:hover {
      cursor: pointer;
    }
  }
</style>
